import React from 'react';
import { useTranslation } from 'react-i18next';


const Loader = ({ fullScreen = true, size = 'default', message = '' }) => {
  const sizeClasses = {
    small: 'w-8 h-8 border-[3px]',
    default: 'w-12 h-12 border-4',
    large: 'w-16 h-16 border-4',
  };

  const spinner = (
    <div className="text-center">
      <div className={`${sizeClasses[size] || sizeClasses.default} border-blue-200 border-t-blue-500 rounded-full animate-spin mx-auto`} />
      {message && <p className="text-gray-500 text-sm mt-3">{message}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        {spinner}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-16">
      {spinner}
    </div>
  );
};

export default Loader;